export default function convertClassType(type) {
    switch(type) {
        case 'Feminina': return 'F';
        case 'Masculina': return 'M';
        case 'Mista': return 'MF';
        case 'F': return 'Feminina';
        case 'M': return 'Masculina';
        case 'MF': return 'Mista';
        default: return '-'
    }
}